/* eslint-disable */
define(
  'modules/tile-nav',
  [
    'jquery',
    'vendor/slick',
    'modules/utils',
    'modules/spin-loader',
    'modules/tracking',
    'modules/navigation',
    'modules/animation'
  ],
  function (
    $,
    slick,
    M_Utils,
    M_SpinLoader,
    M_Tracking,
    M_Navigation,
    M_Animation
  ) {
    'use strict';

    var selectors = {
      exterior: {
        slider: '.js-nav-exterior-slider',
        overlay: '.js-screen-nav-exterior-overlay'
      },
      interior: {
        slider: '.js-nav-interior-slider',
        overlay: '.js-screen-nav-interior-overlay'
      },
      tile: '.js-nav-tile',
      exploringLabel: '.js-nav-tile-exploring'
    };
    var state = {
      spinStarted: false,
      headTrackingStarted: false
    };
    var $sliders = {
      interior: $(),
      exterior: $()
    };
    var $overlays = {
      interior: $(),
      exterior: $()
    };
    var $tiles = {
      interior: $(),
      exterior: $()
    };

    var mouseDownCoord = {
      x: 0,
      y: 0
    };
    var maxSqMouseDeltaForClick = 2;

    function init () {
      getElems();
      bindEvents();
    }

    function getElems () {
      $sliders.exterior = $(selectors.exterior.slider);
      $sliders.interior = $(selectors.interior.slider);
      $overlays.exterior = $(selectors.exterior.overlay);
      $overlays.interior = $(selectors.interior.overlay);
      $tiles.exterior = $sliders.exterior.find(selectors.tile);
      $tiles.interior = $sliders.interior.find(selectors.tile);
    }

    function bindEvents () {
      var carViews = M_Utils.getCarViews();
      var subViews = M_Utils.getSubViews();

      $overlays.exterior.on('click', function (e) {
        closeNav(carViews.exterior);
      });
      $overlays.interior.on('click', function (e) {
        closeNav(carViews.interior);
      });

      M_Utils.addListener('nx-startspin-exterior', function (e) {
        loadView(carViews.exterior, subViews.features);
      });
      M_Utils.addListener('nx-startspin-interior', function (e) {
        loadView(carViews.interior, subViews.features);
      });

      bindSliderEvents();
    }

    function bindSliderEvents () {
      var carViews = M_Utils.getCarViews();

      $tiles.exterior.off('mousedown').on('mousedown', onTileMouseDown);
      $tiles.exterior.off('mouseup').on('mouseup', function (e) {
        onTileMouseUp(e, carViews.exterior);
      });
      $tiles.interior.off('mousedown').on('mousedown', onTileMouseDown);
      $tiles.interior.off('mouseup').on('mouseup', function (e) {
        onTileMouseUp(e, carViews.interior);
      });
    }

    function onTileMouseDown (e) {
      mouseDownCoord.x = e.clientX;
      mouseDownCoord.y = e.clientY;
    }

    function onTileMouseUp (e, view) {
      var deltaX = e.clientX - mouseDownCoord.x;
      var deltaY = e.clientY - mouseDownCoord.y;

      if ((deltaX * deltaX) + (deltaY * deltaY) < maxSqMouseDeltaForClick) {
        onTileClick(e, view);
      }
    }

    function onTileClick (e, view) {
      e.preventDefault();

      var viewCapitalized = M_Utils.capitalizeFirstLetter(view);
      var subView = $(e.currentTarget).data('subview');

      if (!M_Utils.getSubViews().hasOwnProperty(subView)) {
        return;
      }

      M_Tracking.trackEvent('click-cta', viewCapitalized + ' ' + subView);

      switchToView(view, subView);
      closeNav(view);
    }

    function initSlider (view) {
      var carViews = M_Utils.getCarViews();

      if (!carViews.hasOwnProperty(view)) {
        return;
      }

      initSliderOnElem($sliders[view]);
    }

    function destroySlider (view) {
      var carViews = M_Utils.getCarViews();

      if (!carViews.hasOwnProperty(view)) {
        return;
      }

      destroySliderOnElem($sliders[view]);
    }

    function initSliderOnElem ($elem) {
      if ($elem.hasClass('slick-initialized')) {
        return;
      }

      $elem.off('init reInit').on('init reInit', bindSliderEvents);

      $elem.slick({
        mobileFirst: true,
        slidesToShow: 1,
        focusOnChange: true,
        arrows: false,
        infinite: false,
        rtl: M_Utils.getIsRTL(),
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            focusOnChange: false
          }
        }]
      });
    }

    function destroySliderOnElem ($elem) {
      if ($elem.hasClass('slick-initialized')) {
        $elem.slick('unslick');
      }
    }

    function closeNav (view) {
      M_Utils.triggerEvent('nx-hide-nav-' + view);
    }

    function loadView (view, subView, immediate, isInitialLoad) {
      resetLoadingCompleted();
      M_Navigation.showControls(false);

      var viewCapitalized = M_Utils.capitalizeFirstLetter(view);

      if (!isInitialLoad) {
        M_Tracking.trackEvent('change-view', viewCapitalized + ' ' + subView);
      }

      if (immediate) {
        startSpin(view, subView, isInitialLoad);
        return;
      }

      M_Animation.playSequence('screenNav' + viewCapitalized + 'Exit');

      M_Utils.triggerEvent('nx-loading-' + view, { subView: subView, onComplete: function () {
        startSpin(view, subView, isInitialLoad);
      }});
    }

    function startSpin (view, subView, isInitialLoad) {
      M_SpinLoader.spinStart(view, subView, undefined, onSpinStarted, isInitialLoad);
      updateExploringLabel(view, subView);
    }

    function resetLoadingCompleted () {
      state.spinStarted = false;
      state.headTrackingStarted = false;
    }

    function onSpinStarted () {
      M_Utils.triggerEvent('nx-loading-complete');
      state.spinStarted = true;
    }

    function switchToView (view, subView) {
      loadView(view, subView);
    }

    function updateExploringLabel (view, subView) {
      var carViews = M_Utils.getCarViews();
      
      if (!carViews.hasOwnProperty(view)) {
        return;
      }

      $(selectors.exploringLabel).hide();
      
      $tiles[view].each(function (idx, elem) {
        var $tile = $(elem);

        if ($tile.data('subview') === subView) {
          $tile.find(selectors.exploringLabel).show();
          return;
        }
      });
    }

    return {
      init: init,
      initSlider: initSlider,
      destroySlider: destroySlider,
      loadView: loadView
    }
});

